import { type ReactNode } from "react";

import { ShieldX } from "lucide-react";

import { useModulePermissions } from "@/features/manifest/model/useModulePermission";

import { useVisibleSettingsSections } from "../model/useVisibleSettingsSections";

export function SettingsPageGuard({ children }: { children: ReactNode }) {
  const visible = useVisibleSettingsSections();
  const { loading, fullAccess } = useModulePermissions();

  if (loading && !fullAccess && visible.length === 0) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center text-sm text-muted-foreground">
        Checking permissions…
      </div>
    );
  }

  if (visible.length === 0) {
    return (
      <div className="flex min-h-[60vh] flex-col items-center justify-center px-6 text-center">
        <ShieldX className="mb-4 h-12 w-12 text-muted-foreground" />
        <h2 className="mb-2 text-lg font-semibold">
          You don&apos;t have access to Settings
        </h2>
        <p className="max-w-md text-sm text-muted-foreground">
          Your administrator has not granted you access to this area. Contact
          them if you need permission.
        </p>
      </div>
    );
  }

  return <>{children}</>;
}
